<template>
  <UpdateField
    :value="item.pricing.price / item.building.total"
    :isEdit="isEdit"
    :cancel="cancel"
    :open="open"
    @updateProperty="handleUpdate(item._id, $event)"
  >
    <span>
      $
      {{ getSquareMeterPrice({ ...item.pricing, ...item.building }) }}
      m<sup>2</sup>
    </span>
  </UpdateField>
</template>
<script>
export default {
  name: "FieldM2",
  components: {
    UpdateField: () => import("./UpdateField.vue")
  },
  props: {
    role: String,
    item: { type: Object, required: true },
    cancel: { type: Function, default: () => {} },
    open: { type: Function, default: () => {} }
  },
  computed: {
    isEdit() {
      return this.role === "admin" || this.role === "superadmin";
    }
  },
  methods: {
    getSquareMeterPrice({ price, currency, construction, terrace, total }) {
      if (!price || price === 0 || !currency) return "";

      if (total) {
        return total === 0
          ? ""
          : parseFloat(price / total)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              .concat(" " + currency);
      } else if (construction && terrace) {
        let result = parseFloat(construction) + parseFloat(terrace);
        result.toFixed(2);
        return result < 1
          ? ""
          : parseFloat(price / result)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              .concat(" " + currency);
      } else if (construction) {
        return construction < 1
          ? ""
          : parseFloat(price / construction)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              .concat(" " + currency);
      } else if (terrace) {
        return terrace < 1
          ? ""
          : parseFloat(price / terrace)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              .concat(" " + currency);
      }
      return "";
    },
    handleUpdate(id, data) {
      const totalPrice = data * this.item.building.total;
      this.$emit("updateProperty", { id, data: totalPrice });
      //this.$emit("updateProperty", { id, data });
    }
  }
};
</script>
<style lang=""></style>
